import { render } from "./PassengerCreateModal.vue?vue&type=template&id=36e53ac2&scoped=true"
import script from "./PassengerCreateModal.vue?vue&type=script&lang=js"
export * from "./PassengerCreateModal.vue?vue&type=script&lang=js"

import "./PassengerCreateModal.vue?vue&type=style&index=0&id=36e53ac2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e53ac2"]])

export default __exports__